<div>
	<div class="ibox-title">
		<h5>CAASS Visitors Status for {{ Title }}</h5>
	</div>

	<div class="ibox-content">
		<!--Options-->
		<div class="ButtonGrid">
			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 0,
					'btn-warning': OptionID == 0
				}"
				(click)="SelectOption(0)"
			>
				Facility
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 1,
					'btn-warning': OptionID == 1
				}"
				(click)="SelectOption(1)"
			>
				District
			</button>
		</div>

		<!--Loading Overlay-->
		<div class="CenterDiv" *ngIf="Inited == false">
			<p-progressSpinner></p-progressSpinner>
		</div>

		<!--Table-->
		<div class="table-main-body" *ngIf="Inited == true">
			<p-table
				#mydt
				[value]="lstScanStation"
				[loading]="loading"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedScanStation"
				dataKey="ScanStationID"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Filter or Select from Dropdown-->
					<tr>
						<!--INSERT CUSTOM FILTERS HERE-->

						<!--ScanStation-->
						<th>
							<p-columnFilter type="text" field="ScanStation" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--FacilityName-->
						<th>
							<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterFacilityName
										[ngModel]="value"
										[options]="lstFacilityName"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<!--FacilityLocationName-->
						<th>
							<p-columnFilter field="FacilityLocationName" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterFacilityLocationName
										[ngModel]="value"
										[options]="lstFacilityLocationName"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<!--IsScanStationDesc-->
						<th>
							<p-columnFilter field="IsScanStationDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterIsScanStationDesc
										[ngModel]="value"
										[options]="lstIsScanStationDesc"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
					</tr>

					<!--Column Names-->
					<tr style="height: 4rem">
						<!--INSERT CUSTOM COLUMNS HERE-->
						<th pSortableColumn="ScanStation">Station Name<p-sortIcon field="ScanStation"></p-sortIcon></th>
						<th pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
						<th pSortableColumn="FacilityLocationName">Location<p-sortIcon field="FacilityLocationName"></p-sortIcon></th>
						<th pSortableColumn="IsScanStationDesc">Running ScanStation<p-sortIcon field="IsScanStationDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-ScanStation>
					<tr [pSelectableRow]="ScanStation">
						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ ScanStation.ScanStation }}
						</td>

						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ ScanStation.FacilityName }}
						</td>

						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ ScanStation.FacilityLocationName }}
						</td>

						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ ScanStation.IsScanStationDesc }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>
